import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const ITEMS = [
  "Standard Cleaning",
  "Deep Cleaning",
  "Move-In / Move-Out",
  "Post-Construction",
  "Commercial Spaces & Offices",
  "B&B & Airbnb Turnovers",
  "Airbnb & Property Management",
  "Clean spaces, better places",
];

export default function EditorialMarquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="border-y border-ink/10 bg-salt py-6"
      aria-hidden="true"
    >
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="mx-6 flex items-center gap-12">
            <span className="font-serif text-2xl italic tracking-tight text-ink/80 md:text-3xl">
              {item}
            </span>
            <Asterisk className="h-5 w-5 text-seafoam" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
